import { Injectable } from '@angular/core';
import { UliBriefInitialState, UliBriefLoad } from './uli-brief.actions';
import { UliBriefModel } from '../models/uli-brief.model';
import { UliBriefState } from './uli-brief.state';
import { UliActivityType } from '../../../../../../common/constants/uli';
import { SetInitialStateFacade } from '../../../../../../common';
import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';
import {
  BriefLocationInfoInterface,
  BriefLocationInfoModel,
  ActionBriefInterface,
  ActionBriefModel,
} from '../../models';

@Injectable({ providedIn: 'root' })
export class UliBriefFacade implements SetInitialStateFacade, BriefLocationInfoInterface, ActionBriefInterface {
  uli$: Observable<UliBriefModel> = this.store.select(UliBriefState.getUliBrief);
  locationInfo$: Observable<BriefLocationInfoModel> = this.store.select(UliBriefState.getLocationInfo);
  actionBriefDetails$: Observable<ActionBriefModel> = this.store.select(UliBriefState.getActionBriefDetails);
  loaded$: Observable<boolean> = this.store.select(UliBriefState.getLoaded);

  constructor(private store: Store) {}

  getUliBrief(compartmentId: number, type: UliActivityType, uli: string): void {
    this.store.dispatch(new UliBriefLoad({ compartmentId, type, uli }));
  }

  setInitialState(): void {
    this.store.dispatch(new UliBriefInitialState());
  }
}
